import type { ApiRequest } from '~/common/api/@types'
import { Api } from '~/utils/api'

import { getAuthToken } from './authToken'
import { getEcommerceReferer } from './ecommerceReferer'
import { getWidgetMode } from './widgetMode'

const DEFAULT_HEADERS = { 'Content-Type': 'application/vnd.api+json' }

export class AppApi extends Api {
  protected async fetch<T>(
    method: RequestInit['method'],
    { path, body, query, headers }: ApiRequest,
  ) {
    const EcommerceReferer = getEcommerceReferer()
    const Authorization = getAuthToken()
    const widgetMode = getWidgetMode()

    if (
      typeof query?.sort === 'object' &&
      query.sort !== null &&
      'field' in query.sort &&
      typeof query.sort.field === 'string' &&
      'order' in query.sort &&
      typeof query.sort.order === 'string'
    ) {
      query.sort = `${query.sort.order === 'descend' ? '-' : ''}${query.sort.field}`
    }

    if (query?.pagination) {
      query.page = query?.pagination
      delete query?.pagination
    }

    return super.fetch<T>(method, {
      path,
      body,
      query,
      headers: {
        ...DEFAULT_HEADERS,
        ...(EcommerceReferer ? { 'Ecommerce-Referer': EcommerceReferer } : {}),
        ...(Authorization ? { Authorization: `Bearer ${Authorization}` } : {}),
        ...(widgetMode ? { 'Ccn-App': widgetMode } : {}),
        ...headers,
      },
    })
  }
}
